import React from "react";

import { Dropdown } from "react-bootstrap";

import { Settings, User } from "react-feather";

import avatar1 from "../../assets/img/avatars/avatar.jpg";
import useAuth from "hooks/useAuth";
import { PROFILE } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const NavbarUser = () => {
  const { signOut, user } = useAuth();
  const navigate = useNavigate();

  return (
    <Dropdown className="nav-item" align="end">
      <span className="d-inline-block d-sm-none">
        <Dropdown.Toggle as="a" className="nav-link">
          <img
            src={user?.image ? user.image : avatar1}
            className="avatar img-fluid rounded-circle me-1"
            alt=""
          />
        </Dropdown.Toggle>
      </span>
      <span className="d-none d-sm-inline-block">
        <Dropdown.Toggle as="a" className="nav-link">
          <img
            src={user?.image ? user.image : avatar1}
            className="avatar img-fluid rounded-circle me-1"
            alt=""
          />
          <span className="text-dark">
            {user?.first_name
              ? `${user.first_name} ${user.last_name}`
              : user?.username}
          </span>
        </Dropdown.Toggle>
      </span>
      <Dropdown.Menu drop="end">
        <Dropdown.Item onClick={() => navigate(PROFILE)}>
          <User size={18} className="align-middle me-2" />
          Profile
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={(e) => signOut()}>Sign out</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarUser;
